import { MiscState } from 'stores/types';

export const initialState: MiscState = {
  metaFilter: '',
  groundingQuery: '',
};
